<template>
    <div class="slides__slide text intro grid-container">
        <div class="grid-x grid-padding-x align-center">
            <div class="cell medium-20 large-12">
                <div class="text-content">
                    <h1>{{ slidedata.title }}</h1>
                    <p v-html="slidedata.description" />
                </div>

                <div class="offerte-form">
                    <div class="offerte-form">
                        <div class="grid-x grid-padding-x">
                            <div class="cell">
                                <label>{{ $appdata.translations['form.offerte.bedrijfsnaam.label'] }}</label>

                                <ErrorField :errors="errorObject" field="bedrijfsnaam" />

                                <div class="formfield input">
                                    <input type="text" v-model="formData.bedrijfsnaam" :placeholder="$appdata.translations['form.offerte.bedrijfsnaam.placeholder']">
                                </div>
                            </div>
                        </div>
                        <div class="grid-x grid-padding-x">
                            <div class="cell">
                                <label class="required">{{ $appdata.translations['form.offerte.dealer.label'] }}</label>

                                <ErrorField :errors="errorObject" field="dealer" />

                                <div class="formfield input">
                                    <input type="text" v-model="formData.dealer" :placeholder="$appdata.translations['form.offerte.dealer.placeholder']">
                                </div>
                            </div>
                        </div>
                        <div class="grid-x grid-padding-x">
                            <div class="cell">
                                <label class="required">{{ $appdata.translations['form.offerte.naam_contactpersoon.label'] }}</label>

                                <ErrorField :errors="errorObject" field="naamContactpersoon" />

                                <div class="formfield input">
                                    <input type="text" v-model="formData.naamContactpersoon" required="required" :placeholder="$appdata.translations['form.offerte.naam_contactpersoon.placeholder']">
                                </div>
                            </div>
                        </div>
                        <div class="grid-x grid-padding-x">
                            <div class="cell">
                                <label class="required">{{ $appdata.translations['form.offerte.telefoonnummer_contactpersoon.label'] }}</label>

                                <ErrorField :errors="errorObject" field="telefoonContactpersoon" />

                                <div class="formfield input">
                                    <input type="text" v-model="formData.telefoonContactpersoon" required="required" :placeholder="$appdata.translations['form.offerte.telefoonnummer_contactpersoon.placeholder']">
                                </div>
                            </div>
                        </div>
                        <div class="grid-x grid-padding-x">
                            <div class="cell">
                                <label class="required">{{ $appdata.translations['form.offerte.email.label'] }}</label>

                                <ErrorField :errors="errorObject" field="email" />

                                <div class="formfield input">
                                    <input type="text" v-model="formData.email" required="required" :placeholder="$appdata.translations['form.offerte.email.label']">
                                </div>
                            </div>
                        </div>

                        <div class="grid-x grid-padding-x">
                            <div class="cell small-12 medium-6">
                                <label class="required" for="offerte_zipcode">{{ $appdata.translations['form.offerte.postcode.label'] }}</label>
                            </div>
                            <div class="cell small-12 medium-6">
                                <label class="required" for="offerte_streetNumber">{{ $appdata.translations['form.offerte.huisnummer.label'] }}</label>
                            </div>
                        </div>

                        <div class="grid-x grid-padding-x">
                            <div class="cell">
                                <ErrorField :errors="errorObject" field="zipcode" />
                                <ErrorField :errors="errorObject" field="streetNumber" />
                            </div>
                        </div>

                        <div class="grid-x grid-padding-x">

                            <div class="cell small-12 medium-6">
                                <div class="formfield">
                                    <input type="text" v-model="formData.zipcode" required="required" :placeholder="$appdata.translations['form.offerte.postcode.placeholder']">
                                </div>
                            </div>
                            <div class="cell small-12 medium-6">
                                <div class="formfield">
                                    <input type="text" v-model="formData.streetNumber" required="required" :placeholder="$appdata.translations['form.offerte.huisnummer.placeholder']">
                                </div>
                            </div>
                        </div>


                        <div class="grid-x grid-padding-x">
                            <div class="cell">
                                <label class="required">{{ $appdata.translations['form.offerte.city.label'] }}</label>

                                <ErrorField :errors="errorObject" field="city" />

                                <div class="formfield input">
                                    <input type="text" v-model="formData.city" :placeholder="$appdata.translations['form.offerte.city.placeholder']">
                                </div>
                            </div>
                        </div>

                        <div class="grid-x grid-padding-x">
                            <div class="cell">
                                <label for="offerte_opmerking">{{ $appdata.translations['form.offerte.opmerking.label'] }}</label>

                                <ErrorField :errors="errorObject" field="opmerking" />

                                <div class="formfield textarea">
                                    <textarea v-model="formData.opmerking" :placeholder="$appdata.translations['form.offerte.opmerking.placeholder']"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="grid-x grid-padding-x">
                            <div class="cell">
                                <div class="required-desc">
                                    <span class="required"></span> {{ $appdata.translations['form.required.field'] }}
                                </div>
                            </div>
                        </div>

                        <button class="btn btn--fill" @click="submit()">{{ $appdata.translations['form.offerte.button'] }}<i class="icon-arrow-right"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api';
import ErrorField from '@/components/errorField.vue';

export default {
    components: {
        ErrorField,
    },
    data() {
        return {
            formData: {
                bedrijfsnaam: '',
                naamContactpersoon: '',
                telefoonContactpersoon: '',
                email: '',
                zipcode: '',
                streetNumber: '',
                opmerking: '',
                dealer: '',
                city: '',
            },
            errorObject: {},
            loading: false,
        };
    },
    props: {
        slidedata: {
            default() {
                return {};
            },
            type: Object,
        },
        datamodel: {
            default() {
                return {};
            },
            type: Object,
        },
    },
    methods: {
        async submit() {
            if (this.loading) {
                return;
            }

            this.errorObject = {};
            this.loading = true;

            API.post('/process-form', {
                form: this.formData,
                type: "form",
                entity_id: this.datamodel.entity_id,
                accessory: this.datamodel.accessory,
            }).then((response) => {
                this.loading = false;
                this.$emit('finalStep', response.data);
            }).catch((error) => {
                const errorObject = {};
                this.loading = false;

                window.scrollTo(0, 0);

                error.response.data.errors.forEach((fieldError) => {
                    errorObject[fieldError.name] = fieldError;
                });

                this.errorObject = errorObject;
            });
        },
    },
};
</script>
